import { render } from "./featuredFaqBlock.vue?vue&type=template&id=36ef79ec&scoped=true&ts=true"
import script from "./featuredFaqBlock.vue?vue&type=script&lang=ts"
export * from "./featuredFaqBlock.vue?vue&type=script&lang=ts"

import "./featuredFaqBlock.vue?vue&type=style&index=0&id=36ef79ec&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36ef79ec"]])

export default __exports__